import type { PlayerRecord } from "../db/entities/Player";

export function playerMarketingEmailsEnabled(
  player: Pick<PlayerRecord, "marketingEmailsEnabled">,
): boolean {
  return player.marketingEmailsEnabled !== false;
}

export function marketingEmailsEnabledToUnsubscribed(
  player: Pick<PlayerRecord, "marketingEmailsEnabled"> | null,
): boolean {
  return player?.marketingEmailsEnabled === false;
}
